module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayRegular.2071d26.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayRegular.eot
// module id = S2FB
// module chunks = 1